import React, { useRef, useState } from 'react';
import {
  Modal,
  PrimaryButton,
  DefaultButton,
} from '@fluentui/react';
import Cropper, { ReactCropperElement } from 'react-cropper';
import 'cropperjs/dist/cropper.css';

export const PreviewCropModal = ({
  image,
  onCropComplete,
  onClose,
  aspect = 3 / 1,
}: {
  image: string;
  onCropComplete: (croppedImageUrl: string) => void;
  onClose: () => void;
  aspect?: number;
}) => {
  const cropperRef = useRef<ReactCropperElement>(null);
  const [isCropping, setIsCropping] = useState(false);

  const handleSave = () => {
    const cropper = cropperRef.current?.cropper;

    if (!cropper) {
      console.error('Cropper ещё не инициализирован');
      return;
    }

    setIsCropping(true);

    try {
      const outputWidth = 900;
      const outputHeight = Math.round(outputWidth / aspect);

      const croppedCanvas = cropper.getCroppedCanvas({
        width: outputWidth,
        height: outputHeight,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });

      if (!croppedCanvas) {
        throw new Error('Не удалось получить canvas');
      }

      const croppedImage = croppedCanvas.toDataURL('image/jpeg', 0.95);

      onCropComplete(croppedImage);
      onClose();
    } catch (error) {
      console.error('Ошибка при обрезке изображения:', error);
    } finally {
      setIsCropping(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      onDismiss={onClose}
      isBlocking={true}
      styles={{
        main: {
          width: 700,
          maxWidth: '90vw',
          padding: 24,
          borderRadius: 8,
          backgroundColor: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
        root: {
          zIndex: 100000,
        },
      }}
    >
      <div>
        <h3>Обрежьте изображение</h3>

        <p
          style={{
            fontSize: 14,
            color: '#605e5c',
            marginTop: -10,
          }}
        >
          Перетащите изображение или измените масштаб
        </p>

        <div
          style={{
            width: '100%',
            height: 400,
            marginTop: 16,
            background: '#f5f5f5',
            borderRadius: 4,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Cropper
            ref={cropperRef}
            src={image}
            style={{
              width: '100%',
              height: '100%',
            }}
            aspectRatio={aspect}
            viewMode={1}
            dragMode="move"
            autoCropArea={0.8}
            guides={true}
            background={false}
            responsive={true}
            restore={false}
            center={true}
            checkOrientation={false}
          />
        </div>

        <div
          style={{
            display: 'flex',
            gap: 10,
            marginTop: 20,
            justifyContent: 'flex-end',
          }}
        >
          <DefaultButton
            text="Отмена"
            onClick={onClose}
            disabled={isCropping}
          />

          <PrimaryButton
            text={isCropping ? 'Обработка...' : 'Сохранить'}
            onClick={handleSave}
            disabled={isCropping}
          />
        </div>
      </div>
    </Modal>
  );
};